import { createContext } from "react";

type SimpleValue = string | number | boolean | null;

export interface ErrorContextInfo {
  key: string;
  value: SimpleValue;
}

export interface ErrorDisplayInfo extends ErrorContextInfo {
  label: string;
}

export interface ErrorBoundaryInfoContextValue {
  info: Record<string, SimpleValue>;
  addOrUpdateInfo(info: ErrorContextInfo): void;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const ErrorInfoContext = createContext<ErrorBoundaryInfoContextValue>(undefined!);
